import { render, staticRenderFns } from "./CustomAddressf.vue?vue&type=template&id=3a6e85b6"
import script from "./CustomAddressf.vue?vue&type=script&lang=js"
export * from "./CustomAddressf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapAddress: require('/opt/atlassian/pipelines/agent/build/components/Map/Address.vue').default})
